import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import InscricaoEntity from 'entity/Inscricao'
import { useTranslation } from 'react-i18next';
import { useRodada } from 'entity/Rodada/hook/RodadaHooks';
import InscricaoSimplificadaBox from './InscricaoSimplificadaBox';
import {
    Box,
    CircularProgress,
    Typography,
    Container,
    Paper,
    Fade,
    Alert,
    AlertTitle,
    Button,
    LinearProgress
} from '@mui/material';
import {
    CheckCircleOutline as SuccessIcon,
    EventBusy as EventBusyIcon,
    ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

function InscricaoSimplificadaInter(props) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { t } = props;
    const searchUidRodada = searchParams.get("rodada")
    const { rodada: rodadaFromHook, loading } = useRodada(searchUidRodada)
    const [countdown, setCountdown] = useState(5);
    const [isRedirecting, setIsRedirecting] = useState(false);

    // Notei que quando o usuário finalizava o cadastro, era redirecionado para outro endpoint sem o uid da rodada
    // isso causava aquele erro de "rodada não encontrada" mesmo quando a rodada existia, pois o hook useRodada sempre retornava undefined.
    // 
    const [rodadaSalva, setRodadaSalva] = useState(null);

    useEffect(() => {
        if (rodadaFromHook && !rodadaSalva) {
            setRodadaSalva(rodadaFromHook);
        }
    }, [rodadaFromHook, rodadaSalva]);

    const rodada = props.values.rodada || rodadaSalva || rodadaFromHook;

    useEffect(() => {
        if (rodada) {
            props.form.change("rodada", rodada)
            props.form.change("tipo", "FORNECEDOR")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rodada]);

    useEffect(() => {
        if (props.values.uid && rodada) {
            setIsRedirecting(true);

            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        navigate(`/painel-inscrito?uid=${props.values.uid}`);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [props.values.uid, rodada, navigate]);

    const handleManualRedirect = () => {
        if (props.values.uid && rodada) {
            navigate(`/painel-inscrito?uid=${props.values.uid}`);
        }
    };

    if (searchUidRodada && !rodada && loading) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    }}
                >
                    <Fade in timeout={800}>
                        <Box>
                            <CircularProgress
                                size={60}
                                thickness={4}
                                sx={{ mb: 3, color: 'primary.main' }}
                            />
                            <Typography
                                variant="h5"
                                fontWeight={600}
                                color="primary.main"
                                gutterBottom
                            >
                                Carregando rodada...
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Aguarde enquanto buscamos as informações
                            </Typography>
                        </Box>
                    </Fade>
                </Paper>
            </Container>
        );
    }

    if (searchUidRodada && !rodada && !loading) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert
                    severity="error"
                    sx={{
                        borderRadius: 4,
                        p: 3,
                        '& .MuiAlert-icon': {
                            fontSize: '2rem'
                        }
                    }}
                >
                    <AlertTitle sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
                        Rodada não encontrada
                    </AlertTitle>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        Por favor, verifique o link ou entre em contato com o organizador.
                    </Typography>
                </Alert>
            </Container>
        );
    }

    if (!rodada) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        Carregando informações...
                    </Typography>
                </Paper>
            </Container>
        );
    }

    let rodadaAceitaInscricao = rodada?.status === "ATIVO"
    if (rodada?.bloqueiaInscricaoPublica === "SIM") {
        rodadaAceitaInscricao = false
    }
    if (rodada?.limiteInscricaoPublica) {
        let now = new Date()
        let limite = new Date(rodada?.limiteInscricaoPublica)
        if (now > limite) {
            rodadaAceitaInscricao = false
        }
    }

    if (props.values.uid) {
        return (
            <Container maxWidth="md" sx={{ py: 8 }}>
                <Paper
                    elevation={4}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
                        border: '2px solid',
                        borderColor: 'success.light',
                    }}
                >
                    <Fade in timeout={1000}>
                        <Box>
                            <SuccessIcon
                                sx={{
                                    fontSize: '5rem',
                                    color: 'success.main',
                                    mb: 3,
                                    animation: 'pulse 2s infinite'
                                }}
                            />
                            <Typography
                                variant="h3"
                                fontWeight={700}
                                color="success.dark"
                                gutterBottom
                                sx={{
                                    fontSize: { xs: '1.8rem', sm: '2.5rem' },
                                    mb: 2
                                }}
                            >
                                {t('Inscrição Realizada!')}
                            </Typography>
                            <Typography
                                variant="h6"
                                color="text.primary"
                                sx={{
                                    fontSize: { xs: '1rem', sm: '1.25rem' },
                                    fontWeight: 500,
                                    mb: 2
                                }}
                            >
                                Parabéns! Sua inscrição foi realizada com sucesso.
                            </Typography>
                            <Typography
                                variant="body1"
                                color="text.secondary"
                                sx={{ fontSize: { xs: '0.9rem', sm: '1rem' }, mb: 4 }}
                            >
                                Você receberá um email de confirmação em breve.
                            </Typography>

                            {isRedirecting && (
                                <Box sx={{ mt: 4, mb: 3 }}>
                                    <Typography
                                        variant="h6"
                                        color="primary.main"
                                        sx={{ mb: 2, fontSize: { xs: '1rem', sm: '1.25rem' } }}
                                    >
                                        Redirecionando para o Painel do Inscrito em:
                                    </Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                                        <Typography
                                            variant="h2"
                                            color="primary.main"
                                            sx={{
                                                fontSize: { xs: '2rem', sm: '3rem' },
                                                fontWeight: 700,
                                                fontFamily: 'monospace',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            {countdown}
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            color="primary.main"
                                            sx={{ ml: 1, fontSize: { xs: '1rem', sm: '1.25rem' } }}
                                        >
                                            segundo{countdown !== 1 ? 's' : ''}
                                        </Typography>
                                    </Box>

                                    <LinearProgress
                                        variant="determinate"
                                        value={(5 - countdown) * 20}
                                        sx={{
                                            height: 8,
                                            borderRadius: 4,
                                            mb: 3,
                                            bgcolor: 'rgba(25, 118, 210, 0.1)',
                                            '& .MuiLinearProgress-bar': {
                                                borderRadius: 4,
                                                background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)'
                                            }
                                        }}
                                    />

                                    <Button
                                        variant="contained"
                                        size="large"
                                        onClick={handleManualRedirect}
                                        endIcon={<ArrowForwardIcon />}
                                        sx={{
                                            px: 4,
                                            py: 1.5,
                                            fontSize: { xs: '0.9rem', sm: '1.1rem' },
                                            fontWeight: 600,
                                            borderRadius: 3,
                                            background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 8px 25px rgba(25,118,210,0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        }}
                                    >
                                        Ir Agora para o Painel
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Fade>
                </Paper>
            </Container>
        );
    }

    if (!rodadaAceitaInscricao) {
        return (
            <Container maxWidth="md" sx={{ py: 8 }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                    }}
                >
                    <EventBusyIcon
                        sx={{
                            fontSize: '4rem',
                            color: 'warning.main',
                            mb: 2
                        }}
                    />
                    <Typography
                        variant="h4"
                        fontWeight={700}
                        color="warning.dark"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}
                    >
                        {t('Inscrições Encerradas')}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                    >
                        {t('Esta rodada não está mais aceitando inscrições')}
                    </Typography>
                </Paper>
            </Container>
        );
    }

    return (
        <InscricaoSimplificadaBox rodada={rodada} loading={loading} onSubmit={props.form.submit} submitFailed={props.submitFailed} values={props.values} />
    )
}

export default function InscricaoSimplificadaForm() {
    const { t } = useTranslation()

    return (
        <DefaultEntityCrud
            EntityClass={InscricaoEntity}
            title={t("Inscrição")}
            routeForm="inscrever-se"
            backRoute=""
            afterSave={(values) => {
                InscricaoEntity.sendThankYouEmail(values)
            }}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(props) => {
                return <InscricaoSimplificadaInter t={t} {...props} />
            }}
        </DefaultEntityCrud>
    )
}